// extracted by mini-css-extract-plugin
export default {"center":"Button_center__eBx+R","button":"Button_button__E0e+I","buttonContent":"Button_buttonContent__CtS3b"};